import React from 'react';
import { Link } from 'react-router-dom';
import { STATUS_CONFIG } from '../data/roadmap';

export default function RoadmapTimeline({ phases }) {
  return (
    <div style={timelineStyle}>
      {phases.map((phase, phaseIdx, arr) => {
        const cfg = STATUS_CONFIG[phase.status];
        const isLast = phaseIdx === arr.length - 1;
        const isMuted = phase.status === 'planned';
        return (
          <div key={phase.phase} style={timelineRowStyle}>
            <div style={dotColStyle}>
              <div style={{ ...dotStyle, background: cfg.dot, boxShadow: !isMuted ? `0 0 0 4px ${cfg.dot}26` : 'none' }}>
                {phase.status === 'done' && <span style={checkStyle}>✓</span>}
                {phase.status === 'active' && <span style={activeInnerStyle} />}
              </div>
              {!isLast && <div style={{ ...lineStyle, background: `linear-gradient(to bottom, ${cfg.dot}, ${STATUS_CONFIG[arr[phaseIdx + 1].status].dot})` }} />}
            </div>

            <div style={{ ...phaseCardStyle, borderColor: phase.status === 'active' ? 'rgba(129,140,248,0.35)' : phase.status === 'pipeline' ? 'rgba(245,158,11,0.30)' : 'var(--border)', boxShadow: phase.status === 'active' ? '0 0 0 1px rgba(129,140,248,0.15)' : 'none' }}>
              <div style={phaseHeaderStyle}>
                <h3 style={{ ...phaseTitleStyle, color: isMuted ? 'var(--text-secondary)' : 'var(--text-primary)' }}>{phase.phase}</h3>
                <span style={{ ...phaseBadgeStyle, color: cfg.labelColor, background: cfg.labelBg, border: `1px solid ${cfg.labelBorder}` }}>{cfg.label}</span>
              </div>

              <ul style={itemListStyle}>
                {phase.items.map((item) => (
                  <li key={item.label} style={itemStyle}>
                    <span style={{ ...itemDotStyle, background: item.done ? cfg.dot : 'transparent', borderColor: item.done ? cfg.dot : '#334155' }} />
                    <span style={{ color: item.done ? 'var(--text-primary)' : 'var(--text-secondary)', textDecoration: 'none' }}>{item.label}</span>
                  </li>
                ))}
              </ul>

              {phase.action && (
                <div style={{ marginTop: '16px' }}>
                  <Link to={phase.action.to} style={phaseActionBtn}>{phase.action.label}</Link>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

const timelineStyle = { display: 'grid', gap: 0 };
const timelineRowStyle = { display: 'grid', gridTemplateColumns: '40px 1fr', gap: '0 16px' };
const dotColStyle = { display: 'flex', flexDirection: 'column', alignItems: 'center' };
const dotStyle = { width: '28px', height: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, zIndex: 1, marginTop: '16px' };
const checkStyle = { fontSize: '13px', color: '#052e16', fontWeight: 900 };
const activeInnerStyle = { width: '10px', height: '10px', borderRadius: '50%', background: '#fff', opacity: 0.9 };
const lineStyle = { width: '2px', flex: 1, minHeight: '24px' };

const phaseCardStyle = { background: 'var(--surface-strong)', border: '1px solid var(--border)', borderRadius: '16px', padding: '18px 20px', marginBottom: '12px' };
const phaseHeaderStyle = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', marginBottom: '14px', flexWrap: 'wrap' };
const phaseTitleStyle = { margin: 0, fontSize: '16px', fontWeight: 800 };
const phaseBadgeStyle = { display: 'inline-block', padding: '4px 10px', borderRadius: '999px', fontSize: '12px', fontWeight: 700, flexShrink: 0 };

const itemListStyle = { margin: 0, padding: 0, listStyle: 'none', display: 'grid', gap: '8px' };
const itemStyle = { display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px' };
const itemDotStyle = { width: '8px', height: '8px', borderRadius: '50%', border: '2px solid', flexShrink: 0 };

const phaseActionBtn = { display: 'inline-block', padding: '10px 18px', borderRadius: '10px', background: 'linear-gradient(135deg, var(--primary) 0%, var(--primary-strong) 100%)', color: '#fff', textDecoration: 'none', fontWeight: 700, fontSize: '14px' };
